export enum EXTENSION_ACTIONS {
  login = 'login',
  logout = 'logout',
  redirect = 'redirect',
  redirectReady = 'redirectReady',
  toggleIframe = 'toggleIframe',
  clickGmail = 'clickGmail',
}
